import React from 'react';
import {connect} from 'react-redux';
import {FormattedNumber} from 'react-intl';
import {
    fetchBarReportShifts, deleteBarReportShift, clearBarReportShifts, addBarReportShift,
    closeBarReportShift, barReportShiftsPopupType, changeShiftHourrate, changeShiftTime, openBarReportBarmansPopup
} from '../../../../common/menu/report/shifts/actions';
import Popup from '../../popup/Popup'
import {showPopupInMenu} from '../../../../common/menu/actions';
import CashPopup from './CashPopup';
import TimepickerButton from '../../../components/keyboard/TimepickerButton';
import NumericalButton from '../../../components/keyboard/NumericalButton';
import ArrLeftButton from '../../../components/buttons/ArrLeftButton';
import ArrRightButton from '../../../components/buttons/ArrRightButton';

class Shifts extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        page: React.PropTypes.number,
        limit: React.PropTypes.number,
        max: React.PropTypes.number,
        shifts: React.PropTypes.object,
        barId: React.PropTypes.number,
        addBarReportShift: React.PropTypes.func,
        openBarReportBarmansPopup: React.PropTypes.func,
        deleteBarReportShift: React.PropTypes.func,
        changeShiftTime: React.PropTypes.func,
        closeBarReportShift: React.PropTypes.func,
        showPopupInMenu: React.PropTypes.func,
        changeShiftHourrate: React.PropTypes.func,
        barReportShiftsPopupType: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.openPopup = this.openPopup.bind(this);
        this.setHourRate = this.setHourRate.bind(this);
        this.setTime = this.setTime.bind(this);
    }

    nextPage() {
        const {fetchBarReportShifts, barId, limit, page} = this.props;
        fetchBarReportShifts(barId, limit, page + 1);
    }

    prevPage() {
        const {fetchBarReportShifts, barId, limit, page} = this.props;
        fetchBarReportShifts(barId, limit, page - 1);
    }

    componentWillMount() {
        const {fetchBarReportShifts, barId, limit, page} = this.props;
        fetchBarReportShifts(barId, limit, page);
    }

    componentWillUnmount() {
        const {clearBarReportShifts} = this.props;
        clearBarReportShifts();
    }

    openPopup(shift, openBarmans, disabled = false) {
        if (disabled) {
            return;
        }
        const {showPopupInMenu, barReportShiftsPopupType, openBarReportBarmansPopup} = this.props;
        barReportShiftsPopupType(shift);
        if (openBarmans) {
            openBarReportBarmansPopup(true);
        } else {
            showPopupInMenu(true);
        }
    }

    setHourRate(shiftId, value) {
        const {changeShiftHourrate} = this.props;
        changeShiftHourrate(shiftId, value);
    }

    setTime(shiftId, value, start) {
        const {changeShiftTime, barId} = this.props;
        changeShiftTime(shiftId, value, start, barId);
    }

    render() {
        const {
            shifts, max, page, limit, barId, deleteBarReportShift, closeBarReportShift,
            addBarReportShift, msg
        } = this.props;

        return (
            <div className="menuPage">

                <Popup body={<CashPopup />}/>

                <div className="menuPage-header">
                  <div className="menuPage-header-title">
                    <div className="menuPage-title">
                        {msg.shifts.dailyReport}
                    </div>
                  </div>
                  <div className="menuPage-header-key">
                    <div className={`boxBtn color-white ${page < 1 ? 'disabled' : ''}`}
                         onClick={() => this.prevPage()}>
                        <ArrLeftButton/>
                    </div>
                  </div>
                  <div className="menuPage-header-key">
                    <div className={`boxBtn color-white ${max <= limit || page === (Math.ceil(max / limit) - 1) ? 'disabled' : ''}`}
                         onClick={() => this.nextPage()}>
                        <ArrRightButton/>
                    </div>
                  </div>
                  <div className="menuPage-header-key">
                    <div className={`boxBtn color-green`}
                         onClick={() => addBarReportShift(barId, limit)}>
                        <div className={`boxBtn-inner`}>
                            {msg.shifts.add}
                        </div>
                    </div>
                  </div>
                </div>

                <div className="menuPage-content">
                <div className="table">
                    <div className="table-head">
                        <div className="table-head-row">
                            <div className="table-head-cell" style={{width: '30%'}}>
                                <span>{msg.shifts.barman}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '10%'}}>
                                <span>{msg.shifts.rate}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '10%'}}>
                                <span>{msg.shifts.from}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '10%'}}>
                                <span>{msg.shifts.to}</span>
                            </div>
                            <div className="table-head-cell" style={{width: '10%'}}>
                                <span>{msg.shifts.salary}</span>
                            </div>
                        </div>
                    </div>
                    <div className="table-body">
                        {!!shifts && shifts.map((shift, i) => {
                                const isPaid = shift.get('shiftStateType') === 'PAID';
                                return (
                                    <div className="table-row"
                                         key={`sentBills-${i}`}>

                                        <div className="table-cell" style={{width: '30%'}}>
                                            <div className={`boxBtn text-left text-black ${isPaid ? 'no-click' : 'color-white'}`}
                                                 onClick={() => this.openPopup(shift, true, isPaid)}>
                                                <div className="boxBtn-inner">
                                                    {shift.get('name')}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-cell" style={{width: '10%'}}>
                                            <NumericalButton
                                                label={`${shift.get('name')} - sazba`}
                                                className={`boxBtn text-right text-black ${isPaid ? 'no-click' : 'color-white'}`}
                                                removedClassName="box-button"
                                                onSubmit={(val) => this.setHourRate(shift.get('id'), val)}
                                                value={shift.get('hourRate')}
                                            />
                                        </div>

                                        <div className="table-cell" style={{width: '10%'}}>
                                            <TimepickerButton
                                                label={`${shift.get('name')} - od`}
                                                onSubmit={(val => this.setTime(shift.get('id'), val, true))}
                                                removedClassName="boxBtn"
                                                className={`boxBtn text-black ${isPaid ? 'no-click' : 'color-white'}`}
                                                value={shift.get('startShift')} />
                                        </div>

                                        <div className="table-cell" style={{width: '10%'}}>
                                            {shift.get('shiftStateType') === 'WORKING' &&
                                            <div className="boxBtn">
                                                <div className="boxBtn-inner">
                                                    <span />
                                                </div>
                                            </div>
                                            }
                                            {shift.get('shiftStateType') !== 'WORKING' &&
                                            <TimepickerButton
                                                label={`${shift.get('name')} - do`}
                                                onSubmit={(val => this.setTime(shift.get('id'), val, false))}
                                                removedClassName="boxBtn"
                                                className={`boxBtn text-black ${isPaid ? 'no-click' : 'color-white'}`}
                                                value={shift.get('endShift')}/>
                                            }
                                        </div>

                                        <div className="table-cell" style={{width: '10%'}}>
                                            <div className={`boxBtn text-right text-black`}>
                                                <div className="boxBtn-inner">
                                                    {shift.get('amount') !== null &&
                                                    <FormattedNumber style="decimal"
                                                                     maximumFractionDigits={2}
                                                                     minimumFractionDigits={2}
                                                                     value={shift.get('amount')}/>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-cell" style={{width: '20%'}}>
                                            {shift.get('shiftStateType') === 'WORKING' &&
                                            <div className="boxBtn color-green">
                                                <div className="boxBtn-inner"
                                                     onClick={() => closeBarReportShift(shift.get('id'))}>
                                                    {msg.shifts.endShift}
                                                </div>
                                            </div>
                                            }
                                            {shift.get('shiftStateType') === 'CLOSED' &&
                                            <div
                                                className={`boxBtn color-green ${shift.get('amount') === null || shift.get('amount') === 0 ? 'disabled' : ''}`}
                                                onClick={() => this.openPopup(shift, false, isPaid)}>
                                                <div className="boxBtn-inner">
                                                    {msg.shifts.payFromCashbox}
                                                </div>
                                            </div>
                                            }
                                            {shift.get('shiftStateType') === 'PAID' &&
                                            <div className="boxBtn text-black">
                                                <div className="boxBtn-inner">
                                                    {msg.shifts.paid}
                                                </div>
                                            </div>
                                            }
                                        </div>

                                        <div className="table-cell" style={{width: '10%'}}>
                                            <div className={`boxBtn color-red`}
                                                 onClick={() => deleteBarReportShift(shift.get('id'), barId, limit, page)}>
                                                <div className="boxBtn-inner">
                                                    <span>{msg.global.delete}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                );
                            }
                        )}
                    </div>
                </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    barId: state.bars.getIn(['bar', 'id']),
    limit: state.shifts.get('limit'),
    page: state.shifts.get('page'),
    max: state.shifts.get('max'),
    shifts: state.shifts.get('shifts')
}), {
    fetchBarReportShifts, clearBarReportShifts, addBarReportShift, closeBarReportShift, deleteBarReportShift,
    showPopupInMenu, barReportShiftsPopupType, changeShiftHourrate, changeShiftTime, openBarReportBarmansPopup
})(Shifts);



// WEBPACK FOOTER //
// ./src/browser/menu/report/shifts/Shifts.js